var map = {
	"./logo-alphabet.svg": 1140,
	"./logo-amazon-2.svg": 1141,
	"./logo-amazon.svg": 1142,
	"./logo-azercell.svg": 1143,
	"./logo-bank-of-america.svg": 1144,
	"./logo-barclays.svg": 1145,
	"./logo-bbc.svg": 1146,
	"./logo-bnp-paribas.svg": 1147,
	"./logo-booking.svg": 1148,
	"./logo-citibank.svg": 1149,
	"./logo-coca-cola-auto.svg": 1150,
	"./logo-coca-cola-white.svg": 1537,
	"./logo-coca-cola.svg": 1151,
	"./logo-deloitte.svg": 1152,
	"./logo-experian.svg": 1153,
	"./logo-facebook.svg": 1154,
	"./logo-g.svg": 1538,
	"./logo-goldman-sachs-new.svg": 1155,
	"./logo-goldman-sachs.svg": 1539,
	"./logo-google-new.svg": 1156,
	"./logo-google.svg": 1157,
	"./logo-h.svg": 1158,
	"./logo-henkel.svg": 1159,
	"./logo-hsbc-new.svg": 1160,
	"./logo-hsbc.svg": 1540,
	"./logo-ikea-new.svg": 1161,
	"./logo-ikea.svg": 1541,
	"./logo-infineon.svg": 1162,
	"./logo-instagram.svg": 1163,
	"./logo-jp-morgan.svg": 1164,
	"./logo-jti.svg": 1165,
	"./logo-linkedin.svg": 1166,
	"./logo-meta-new.svg": 1167,
	"./logo-meta.svg": 1542,
	"./logo-morgan-stanley-new.svg": 1168,
	"./logo-morgan-stanley.svg": 1543,
	"./logo-netflix.svg": 1544,
	"./logo-oracle.svg": 1169,
	"./logo-paypal.svg": 1170,
	"./logo-pwc-new.svg": 1171,
	"./logo-pwc.svg": 1545,
	"./logo-spotify.svg": 1546,
	"./logo-tesla.svg": 1172,
	"./logo-visa.svg": 1173,
	"./logo-walmart.svg": 1174,
	"./logo-youtube.svg": 1175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1185;